import { useState, useEffect } from 'react';

import { fetchCompanies } from '../utils/apiCalls';

export function useCompanyProvider(companyId) {
  const [companyProivder, setCompanyProvider] = useState(null);

  useEffect(() => {
    async function fetchCompanyProvider() {
      const companies = companyId ? await fetchCompanies() : [];
      const companyProvider = companies.find(company => company.id === companyId)?.provider || null;
      setCompanyProvider(companyProvider);
    }

    setCompanyProvider(null);
    fetchCompanyProvider();
  }, [companyId]);

  return [companyProivder];
}
